import React, { FC } from 'react';
import { ProductivityStatusInfoProps } from '@v2/pages/batch/details/modules/batch/components/ProductivityStatusInfo/ProductivityStatusInfo';
import { LatestMachineEvent } from '@interfaces/machines';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';
import TimeBlockItem from './TimeBlockItem';
import InputLine from '@components/machines/components/detailsComponents/activeMachine/components/InputLine';
import { useManageActiveEventTimes } from '@v2/pages/batch/details/modules/batch/components/ProductivityStatusInfo/hooks/useManageActiveEventTimes';
import { TimeCategory } from '@interfaces/base';
import BlockWrapper, { BlockWrapperProps } from '@components/common/BlockWrapper';

export interface ActiveEventTimesProps extends Pick<ProductivityStatusInfoProps, 'batch' | 'actualTimeForLatestEvent'>, BlockWrapperProps {
  bg?: string;
  borderRadius?: number;
  setAmountOfLines?: (amountOfLines: number) => void;
  offset?: number;
  eventDetails?: LatestMachineEvent;
  increaseActualTime?: boolean;
  allowedTimeCategories?: TimeCategory[];
}

const ActiveEventTimes: FC<ActiveEventTimesProps> = ({
  batch,
  C,
  title = 'EVENT TIMES',
  withoutShadow = false,
  bg = modalFieldBg,
  borderRadius,
  titleStyles,
  setAmountOfLines,
  offset = 0,
  eventDetails,
  actualTimeForLatestEvent,
  allowedTimeCategories,
  increaseActualTime = true,
}) => {
  const { filteredProductivityStatusBlock } = useManageActiveEventTimes({
    batch,
    actualTimeForLatestEvent,
    eventDetails,
    increaseActualTime,
    offset,
    setAmountOfLines,
    allowedTimeCategories,
  });

  return (
    <BlockWrapper title={title} withoutShadow={withoutShadow} titleStyles={titleStyles}>
      {filteredProductivityStatusBlock.map((item, index) => (
        <InputLine
          {...{
            bg,
            borderBottomRadius: index === filteredProductivityStatusBlock.length - 1,
            borderTopRadius: index === 0,
            data: filteredProductivityStatusBlock,
            onlyLabel: false,
            index,
            i: {
              Component: () => <TimeBlockItem {...{ C, timeBlockItem: item }} />,
            },
            C,
            loading: !!batch,
            withoutStretchingForContainer: true,
          }}
          {...(borderRadius ? { borderRadiusValue: borderRadius } : {})}
          key={item.key}
        />
      ))}
    </BlockWrapper>
  );
};

export default ActiveEventTimes;
